// extracted by mini-css-extract-plugin
export default {"root":"alert_root__X8l1A"};